import { PremiumOnPlatformType } from '@/scenes/Editor/components/Navbar/components/SignInManager'
import store from '@/store/store'
import {
  browserName,
  deviceType,
  fullBrowserVersion,
  isDesktop,
  osName,
  osVersion,
} from 'react-device-detect'

export const handleContactUs = (
  content = '',
  errorDetail?: string,
  subject: string = 'Help'
) => {
  let device = isDesktop ? 'Desktop' : deviceType
  let os = `${osName} ${osVersion} `
  let browser = `${browserName} ${fullBrowserVersion} `
  let bazaartVersion = process.env.REACT_APP_VERSION
  let plan = 'Free'
  let userId = 'Free User'
  let email = ''
  const user = store.getState().editor.user.user
  if (user) {
    if (user.userIsPremium) {
      if (user.userPremiumOnPlatform === PremiumOnPlatformType.ios) {
        plan = 'Premium (App Store)'
      } else if (user.userPremiumOnPlatform === PremiumOnPlatformType.web) {
        plan = 'Premium (Purchased via Web)'
      }
    }
    userId = user.userId
    email = user.email
  }

  // If errorDetail is provided, create and download it as a text file
  if (errorDetail) {
    const blob = new Blob([errorDetail], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `error-detail-${new Date().toISOString().replace(/:/g, '-')}.txt`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  var formattedBody = `${content}\n\n\n\n\nDevice: ${device} \nOS Version: ${os} \nBrowser: ${browser} \nBazaart Version: ${bazaartVersion} \nPlan: ${plan} ${
    userId && userId !== 'Free User' ? `\nUser ID: ${userId}` : ''
  } ${email ? `\nEmail: ${email}` : ''}${
    errorDetail ? '\n\nNote: An error detail file has been downloaded. Please attach it to your email.' : ''
  }`
  window.open(
    `mailto:support@bazaart.com?subject=${encodeURIComponent(
      subject ?? content
    )}&body=${encodeURIComponent(formattedBody)}`
  )
}
